<section class="section-card-content" data-cy="withdraw-card-screen">
  <form [formGroup]="debitAndCreditCardForm">
    <div >
      <p class="label tw-text-[16px]" data-cy="withdraw-card-input-label">{{ 'ui.funding.withdraw.amount' | translate: 'Withdraw Amount' }}</p>
      <div class="amount-row tw-relative">

        <!-- Message section -->
        <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

          <!-- Required -->
          <span
            class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
            *ngIf="formVal['amount'] && formVal['amount']?.errors
              && (formVal['amount'].touched || formVal['amount'].dirty)"
            data-cy="withdraw-card-input-error"
          >
            {{
              formVal['amount']?.errors?.['min']
                ? ('ui.funding.withdraw.min.25' | translate: 'Cannot withdraw less than $25.')
                : formVal['amount']?.errors?.['max']
                  ? ('ui.funding.withdraw.max.500' | translate: 'Cannot withdraw greater than $500.')
                  : ('ui.funding.enter.valid.amount' | translate: 'Please enter valid amount.')
            }}
          </span>
        </span>

        <input
          formControlName="amount"
          id="withdrawAmount"
          (keyup)="withdrawAmount()"
          type="number"
          min="25"
          max="500"
          class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
          placeholder="25"
          pattern="^\d+(\.\d{1,2})?$"
          amwager3DecimalInput
          data-cy="withdraw-card-input"
        />
      </div>
      <div class="tw-flex tw-mt-[6px] tw-mb-[22px] tw-justify-between">
        <span
          (click)="chooseAmount(500.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="withdraw-card-500-btn"
        >
          $500
        </span>
        <span
          (click)="chooseAmount(200.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="withdraw-card-200-btn"
        >
          $200
        </span>
        <span
          (click)="chooseAmount(100.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="withdraw-card-100-btn"
        >
          $100
        </span>
        <span
          (click)="chooseAmount(50.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="withdraw-card-50-btn"
        >
          $50
        </span>
        <span
          (click)="chooseAmount(25.00)"
          class="choose-amount tw-text-[16px]"
          data-cy="withdraw-card-25-btn"
        >
          $25
        </span>
      </div>

      <div class="card-content tw-mt-[70px]">

        <p class="label tw-ml-[9px] tw-mb-[10px]" data-cy="withdraw-card-tbl-title">
          {{ 'account.funding.account.choose' | translate: 'Choose Account:' }}
        </p>
        <div class="card-list-container" data-cy="withdraw-card-tbl">
          <div class="card-lists">
            <div *ngIf="(cards$ | async)| isEmpty" class="tw-pl-[8px] tw-pb-[20px]">
              {{ 'ui.funding.please.add.card.to.withdraw' | translate: 'Please add card to withdraw.' }}
            </div>

            <div
              *ngFor="let card of cards$ | async; let i = index"
              (click)="chooseCard($event, 'debitAndCreditCard', ('card-' + i), card.OrderId)"
              id="card-{{i}}"
              class="card-per-row tw-flex tw-w-full tw-justify-between tw-items-center"
            >
              <ng-container *ngIf="card.Type === 'VI'">
                <div class="tw-flex tw-items-center tw-w-[145px]">
                  <span class="selector tw-flex"></span>
                  <img
                    src="/assets/images/funding/visa_icon.png"
                    alt="{{ 'ui.funding.card.logo' | translate: 'card logo' }}"
                    class="card-logo tw-ml-[9px]"
                  />
                  <span class="card-name tw-text-[13px] tw-text-[#000000] tw-font-bold tw-ml-[8px]">
                    {{ card.Type | cardName }}
                  </span>
                </div>

                <div class="tw-flex">
                  <span class="card-ending tw-text-[12px]">
                    ending
                    <span class="tw-font-bold tw-text-[#000000]">
                      {{ card.LastFour | cardNumEnd }}
                    </span>
                  </span>
                </div>

                <div class="tw-flex">
                  <span class="card-date tw-text-[12px]">
                    {{ card.ExpMonth | cardDate: card.ExpYear }}
                  </span>
                </div>

                <div class="tw-flex">
                </div>
              </ng-container>
            </div>
          </div>
        </div>

      </div>

      <button
        (click)="withdraw()"
        [ngClass]="{'active': (amount && orderId && !isWithDrawing && formVal['amount'].valid)}"
        [disabled]="!amount || !orderId || isWithDrawing || formVal['amount'].invalid"
        class="withdraw-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[10px]"
        data-cy="withdraw-card-btn"
      >
        {{ 'account.funding.withdraw.credit.btn.withdraw' | translate: 'Withdraw Now' }}
      </button>
    </div>
  </form>
</section>
